import { useContext } from "react";
import blackDeleteIcon from "../../assets/black-delete-icon.svg";
import whiteRightIcon from "../../assets/white-right-icon.svg";
import editIcon from "../../assets/edit-latest-icon.svg";
import { CaseStageContext } from "../../dashboard/cases/contexts/CaseContexts";

const AmountandIncentiveDetails = ({ data }) => {
  const { caseDetails } = useContext(CaseStageContext);

  // const dummyData = [
  //   {
  //     speciality: "MG072D",
  //     procedure: "1",
  //     stratification: "NA",
  //   },
  //   {
  //     speciality: "MG072D",
  //     procedure: "1",
  //     stratification: "NA",
  //   },
  //   {
  //     speciality: "MG072D",
  //     procedure: "2",
  //     stratification: "Approved",
  //   },
  // ];

  const treatmentPlanData = caseDetails ? caseDetails?.caseprocedures : null;

  return (
    <div className="w-full">
      <div className="w-full h-0 border border-solid border-[#00000010] bg-[#00000010]" />

      <div className="pt-[30px]">
        <div className="grid grid-cols-4 w-full items-start gap-x-[20px]">
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            No.
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Package Code
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Required Quantity
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Remarks
          </div>
        </div>

        <div className="mt-[20px] grid gap-y-[20px]">
          {treatmentPlanData?.map((item, index) => (
            <div
              key={index}
              className="grid grid-cols-4 w-full items-start gap-x-[20px]"
            >
              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {index + 1}.
              </div>

              <div className="break-words font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item.procedureId ?? "--"}
              </div>

              <div className="break-words font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item.unit ?? "--"}
              </div>

              <div className="break-words font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item.remark ?? "--"}
              </div>

              {/* Delete */}
              {/* <button className="flex items-center justify-center bg-transparent border border-none">
                <img src={blackDeleteIcon} alt="delete icon" />
              </button> */}
            </div>
          ))}
        </div>
      </div>

      {/* <div className="flex justify-end items-center gap-[10px] mt-[40px]">
        <button className="w-[170px] h-[74px] xl:w-[101px] xl:h-[42px] 2xl:w-[101px] 2xl:h-[42px] rounded-full border border-none bg-[#5AC69F] flex justify-center items-center gap-[10px] font-lufga text-[14px] text-white font-normal">
          SAVED
          <img src={whiteRightIcon} alt="white icon" />
        </button>

        <button className="w-[42px] h-[42px] rounded-full border border-solid border-[#5AC69F] flex justify-center items-center bg-transparent">
          <img src={editIcon} alt="edit icon" />
        </button>
      </div> */}
    </div>
  );
};

export default AmountandIncentiveDetails;
